import { render } from "./NotLayout.vue?vue&type=template&id=b5a47598&ts=true"
import script from "./NotLayout.vue?vue&type=script&lang=ts"
export * from "./NotLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sfs-projects/development/station-handler-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__